module.exports = __webpack_public_path__ + "img/about-2.982db7af.png";